// Mapowanie numerów jądra Windows NT na nazwy handlowe systemu.
const WINDOWS_NT_VERSIONS: Record<string, string> = {
  "10.0": "10/11",
  "6.3": "8.1",
  "6.2": "8",
  "6.1": "7",
  "6.0": "Vista",
  "5.2": "XP",
  "5.1": "XP",
};

function getWindowsVersion(ua: string): string | null {
  const match = ua.match(/Windows NT ([\d.]+)/i);
  if (!match) return null;
  return WINDOWS_NT_VERSIONS[match[1]] ?? match[1];
}

function getAndroidInfo(ua: string): { version: string | null; model: string | null } {
  const versionMatch = ua.match(/Android ([\d.]+)/i);
  const modelMatch = ua.match(/Android [\d.]+;\s*([^)]+)\)/i);
  let model = modelMatch ? modelMatch[1].split("Build/")[0].trim() : null;
  if (model && /^[a-z]{2}(-[a-z]{2})?$/i.test(model)) model = null; // odrzuca kody językowe np. "en-us"
  return { version: versionMatch ? versionMatch[1] : null, model };
}

function getIosVersion(ua: string): string | null {
  const match = ua.match(/(?:CPU (?:iPhone )?OS|iPhone OS) ([\d_]+)/i);
  return match ? match[1].replace(/_/g, ".") : null;
}

function getMacVersion(ua: string): string | null {
  const match = ua.match(/Mac OS X ([\d_]+)/i);
  return match ? match[1].replace(/_/g, ".") : null;
}

// Wyprowadza czytelny opis urządzenia i systemu operacyjnego (z numerem wersji/modelem) na podstawie nagłówka User-Agent.
export function parseUserAgent(userAgent: string | null | undefined): string {
  if (!userAgent) return "-";
  const ua = userAgent;

  let os = "Nieznany system";
  if (/windows/i.test(ua)) {
    const version = getWindowsVersion(ua);
    os = version ? `Windows ${version}` : "Windows";
  } else if (/android/i.test(ua)) {
    const { version } = getAndroidInfo(ua);
    os = version ? `Android ${version}` : "Android";
  } else if (/iphone|ipad|ipod/i.test(ua)) {
    const version = getIosVersion(ua);
    os = version ? `iOS ${version}` : "iOS";
  } else if (/mac os x/i.test(ua)) {
    const version = getMacVersion(ua);
    os = version ? `macOS ${version}` : "macOS";
  } else if (/linux/i.test(ua)) {
    os = "Linux";
  }

  let device = "Komputer";
  if (/ipad|tablet|(android(?!.*mobile))/i.test(ua)) device = "Tablet";
  else if (/iphone|ipod|mobile|android/i.test(ua)) device = "Telefon";
  else if (/macintosh|windows|linux/i.test(ua)) device = "Komputer/Laptop";

  let model: string | null = null;
  if (/android/i.test(ua)) model = getAndroidInfo(ua).model;
  else if (/ipad/i.test(ua)) model = "iPad";
  else if (/iphone/i.test(ua)) model = "iPhone";
  else if (/ipod/i.test(ua)) model = "iPod";

  const label = model ? `${device} (${os}, ${model})` : `${device} (${os})`;
  return label;
}
